import { uiCapabilityKeys } from "@vega-api/extended/auth/uiCapabilities";
import { getGetUiCapabilitiesForCurrentUserMockHandler } from "@vega-api/generated/auth-permission-v1/auth-permission-v1.msw";
import { type UiCapabilitiesResponse } from "@vega-api/generated/types/uiCapabilitiesResponse";

const allCapabilitiesEnabled = uiCapabilityKeys.reduce(
  (accumulator, capability) => {
    accumulator[capability] = [{ enabled: true }];

    return accumulator;
  },
  {} as UiCapabilitiesResponse,
);

export const getUiCapabilitiesHandler = () =>
  getGetUiCapabilitiesForCurrentUserMockHandler(allCapabilitiesEnabled);
